export const dict = {
    MixedFilterName: "Mixed",
    OverFilterName: "Over",
    UnderFilterName: "Under",
    BetweenFilterName: "to",
    NoBetsTitle: "No bets were found",
    NoBetsInfo: "There are no available Quick SGP bets at the moment. Build your own SGP from the available categories.",
    LiveNoBetsInfo: "There are no available Live Quick SGP bets at the moment.",
    NoBetsForFilterInfo: "There are no available SGP bets for this search criteria. Pick an alternative filter or build your own SGP.",
    LiveNoBetsForFilterInfo: "There are no available Live Quick SGP bets for this search criteria. Pick an alternative filter or build your own SGP.",
    NoBetsViewGameLines: "Build Your Own SGP",
    ViewMore: "More Quick SGPs",
    SgpBadgeTitle: "Open game in SGP mode",
    MiddleTermAt: "at",
    MiddleTermVs: "vs"
};
//# sourceMappingURL=dict.js.map